import { createClientSharedComposable, getStore } from '@global-store/store'
import type { WishlistStore } from '@global-store/stores/wishlist/types'
import { defineStore } from 'pinia'

import {
  type WishlistResponseAttributes,
  addWishlistItem,
  deleteWishlistItem,
  getWishlistById,
} from '@fond-of/shop-api'
import { trackError } from '@fond-of/telemetry'

export const useWishlistStore = createClientSharedComposable(() =>
  defineStore('legacy-wishlist', {
    state: (): WishlistStore => ({
      wishlist: null,
    }),

    getters: {
      itemCount: (state) => state.wishlist?.numberOfItems ?? 0,
      wishlistId: (state) => state.wishlist?.id ?? '',
      wishlistItemsSkus: (state) =>
        state.wishlist?.wishlistItems?.map((item) => item.sku) ?? [],
      isInitialized: (state) => !!state.wishlist?.createdAt,
    },
    actions: {
      setWishlist(wishlist: WishlistResponseAttributes) {
        this.wishlist = wishlist
      },

      async setWishlistItem(item: string) {
        //Type error: links not in 'WishlistItemResponseAttributes'
        //const newItem = await addWishlistItem(this.wishlistId, item)
        try {
          await addWishlistItem(this.wishlistId, item)
          const newWishlist = await getWishlistById(this.wishlistId)
          this.setWishlist(newWishlist)
        } catch (error) {
          trackError(error)
        }
      },

      async removeItem(sku: string) {
        if (!this.wishlist) return
        try {
          await deleteWishlistItem(this.wishlist.id, sku)
          const newWishlist = await getWishlistById(this.wishlistId)
          this.setWishlist(newWishlist)
        } catch (error) {
          trackError(error)
        }
      },
    },
  })(getStore())
)
